import { Badge } from "@radix-ui/themes";
import { SessionTag } from "../../context/useActivityLog";

export const activityTagToBadge: Record<SessionTag, React.ReactNode> = {
  "Good Feedback": null,
  "Bad Feedback": null,
  Improved: (
    <Badge size="1" color="gray">
      Improved
    </Badge>
  ),
  File: (
    <Badge size="1" color="yellow">
      File
    </Badge>
  ),
  "From Ticket": (
    <Badge size="1" color="blue">
      From Ticket
    </Badge>
  ),
  "From Conversation": (
    <Badge size="1" color="purple">
      From Conversation
    </Badge>
  ),
};
